import { ApiClientContext } from "@/stores/api-client-store";
import type { ApiClient } from "@jace/api";
import { useContext } from "react";

export const useApiClient = (): { client: ApiClient } => {
	const ctx = useContext(ApiClientContext);

	if (!ctx) {
		throw new Error("useApiClient must be used within a ApiClientProvider");
	}

	return ctx;
};
